// import { Injectable } from '@angular/core'
// import { Configuration, OpenAIApi } from 'openai'

// @Injectable({
//   providedIn: 'root'
// })
// export class OpenaiService {
//   private openai: OpenAIApi
//   configuration = new Configuration({
//     apiKey: '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',
//   })

//   constructor() {
//     this.openai = new OpenAIApi(this.configuration)
//   }

//   generateText(prompt: string): Promise<string | undefined> {
//     return this.openai.createCompletion({
//       model: 'text-davinci-003',
//       prompt: prompt,
//       max_tokens: 2048
//     })
//       .then(response => response.data.choices[0].text)
//       .catch(error => '')
//   }
// }


import { Injectable } from '@angular/core';
import { Configuration, OpenAIApi } from 'openai';

@Injectable({
  providedIn: 'root'
})
export class OpenaiService {
  private openai: OpenAIApi;
  private systemPrompt = "Ти си асистент интегриран в уеб-базирано приложение за управление на лични финанси и се казваш \"MYLEV помощник\" в приложението MYLEV , което представялва асистент, който помага на потребителите да следят техните трансакции, да задават техни цели. Очаква се от теб най-вече да даваш съвети за финанси и тяхното упралвние. Разделите с който разполага приложението са: Анализи, Трансакции, Цели и Валутен конвертор. Отоговри на този въпрос: ";

  configuration = new Configuration({
    apiKey: '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',
  });

  constructor() {
    this.openai = new OpenAIApi(this.configuration);
  }

  generateText(prompt: string): Promise<string | undefined> {
    const inputPrompt = `${this.systemPrompt}\n${prompt}`;

    return this.openai.createCompletion({
      model: 'text-davinci-003',
      prompt: inputPrompt,
      max_tokens: 2048
    })
      .then(response => response.data.choices[0].text)
      .catch(error => '');
  }
}
